// People are neutral (docs/design/brand-direction/APP-SHELL.md): avatars are grey with initials, and what
// marks a person over a picture (cursors, comment pins) is white with their initials. Colour means a
// department, never a person. Pure.
/** Up to two initials for an avatar ("Dev 2" → "D2", "ana.lima@x" → "AL"). */
export function initialsOf(name: string | null | undefined): string {
  const parts = (name ?? "")
    .replace(/@.*$/, "")
    .replace(/\s*\([^)]*\)\s*$/, "") // "Robin (guest)" → "Robin"
    .split(/[\s._-]+/)
    .filter(Boolean);
  const s = (
    parts.length > 1 ? `${parts[0]![0]}${parts[1]![0]}` : (parts[0] ?? "?").slice(0, 2)
  ).toUpperCase();
  return s || "?";
}

/**
 * Short name for quiet labels ("Following Ana"): the first word, unless the whole name is short enough
 * to say in full ("Dev 2" stays "Dev 2", so it is not confused with "Dev").
 */
export function firstName(name: string | null | undefined): string {
  const n = (name ?? "").replace(/@.*$/, "").trim();
  if (!n) return "someone";
  return n.length <= 12 ? n : (n.split(/\s+/)[0] ?? n);
}
